<template>
  <div class="taste-rating">
    <div class="taste-label">{{ label }}</div>
    <div class="rating-container">
      <div class="rating-bars">
        <div
          v-for="index in rating"
          :key="index"
          class="rating-bar active"
        ></div>
      </div>
      <div class="rating-value">{{ rating }}</div>
      <div class="rating-bars-inactive">
        <div
          v-for="index in maxRating - rating"
          :key="index + rating"
          class="rating-bar inactive"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TasteRating",
  props: {
    /**
     * The label for the taste characteristic (e.g., "Bitterness", "Acidity")
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * The rating value (1-7 scale)
     */
    rating: {
      type: Number,
      required: true,
      validator: (value) => value >= 1 && value <= 7,
    },
    /**
     * Maximum rating scale (default 7)
     */
    maxRating: {
      type: Number,
      default: 7,
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .taste-rating {
    display: flex;
    align-items: center;
    gap: rem(4);
    margin-bottom: rem(8);

    @include media-breakpoint-down(md) {
      flex-direction: column;
      align-items: flex-start;
    }

    .taste-label {
      // font-family: "Nespresso Lucas", sans-serif;
      font-weight: 500;
      font-size: rem(14);
      color: #846a47;
      width: rem(80);
      flex-shrink: 0;
    }

    .rating-container {
      display: flex;
      align-items: center;
      gap: rem(2);
      flex: 1;

      .rating-bars,
      .rating-bars-inactive {
        display: flex;
        gap: rem(2);
        align-items: center;

        .rating-bar {
          width: rem(20);
          height: rem(2);
          background-color: color(lightGray);

          &.active {
            background-color: #846a47;
          }

          &.inactive {
            background-color: #ded7ce;
          }
        }
      }

      .rating-value {
        font-weight: 600;
        font-size: rem(14);
        color: #846a47;
        margin: 0 rem(4);
        min-width: rem(12);
        text-align: center;
      }
    }
  }
}
</style>
